/** Navigation metadata only. This module must never import processing engines. */
export const TOOLS = Object.freeze([
  { id: 'images', label: 'Images', description: 'Convert, resize and compare' },
  { id: 'zip', label: 'ZIP', description: 'Pack, inspect and extract' },
  { id: 'json', label: 'JSON', description: 'Validate, format and minify' },
  { id: 'metadata', label: 'Metadata', description: 'Inspect, remove and verify' },
  { id: 'pdf', label: 'PDF', description: 'Compress, organize and export' },
  { id: 'check', label: 'Check', description: 'Review before sharing' },
  { id: 'vector', label: 'Vector', description: 'Draw, edit SVG and trace images' },
] as const);
export type ToolId = typeof TOOLS[number]['id'];
export type ToolRoute = ToolId | 'collection';
// SVG utility remains reserved pending its own bounded capability decision.
export const RESERVED_ROUTES = Object.freeze(['svg'] as const);
export function isToolId(value: unknown): value is ToolId { return TOOLS.some(tool => tool.id === value); }
export function toolHref(tool: ToolRoute, base = '/'): string { const root = `${base.replace(/\/$/, '')}/`; return tool === 'collection' ? root : `${root}${tool}/`; }
export function routeForPath(pathname: string, base = '/'): ToolRoute | undefined {
  const root = `${base.replace(/\/$/, '')}/`;
  if (pathname === root || pathname === root.slice(0, -1)) return 'collection';
  if (!pathname.startsWith(root)) return undefined;
  const segment = pathname.slice(root.length).replace(/\/$/, '');
  return isToolId(segment) ? segment : undefined;
}
